export default __webpack_public_path__ + "static/media/marker.8fc000d4.svg";